import { Input } from 'components/ui/input';
import { SelectTrigger, SelectValue, SelectContent, SelectItem, Select } from 'components/ui/select';

const rules = ['always-allow', 'always-deny', 'default-deny', 'default-allow'];

const AccessRulesForm = ({ ar, editing = false, onEditField, apps }: IAccessRulesForm) => {
  return (
    <>
      <td>
        {editing ? (
          <Input
            type="text"
            id="app"
            className="w-auto"
            value={ar.application}
            onChange={e => {
              if (!apps.includes(e.target.value)) onEditField('application', e.target.value);
            }}
            placeholder="App"
          />
        ) : (
          ar.application
        )}
      </td>
      <td>
        {editing ? (
          <Select
            value={ar.rule ?? ''}
            onValueChange={val => {
              console.log(val);
              onEditField('rule', val);
            }}
          >
            <SelectTrigger className="w-full max-w-48">
              <SelectValue placeholder="Select rule" />
            </SelectTrigger>
            <SelectContent>
              {rules.map(r => (
                <SelectItem key={r} value={r}>
                  {r}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : (
          ar.rule
        )}
      </td>
    </>
  );
};

interface IAccessRulesForm {
  ar: Partial<IAccessRule>;
  editing: boolean;
  onEditField: (field: keyof IAccessRule, data: string) => void;
  apps: string[];
}

export default AccessRulesForm;
